import { useEffect, useState } from "react";
import { toast, Toaster } from "sonner";
import api from "@/lib/api";
import AdminLayout from "@/pages/admin/AdminLayout";

export default function MessagesAdmin() {
  const [messages, setMessages] = useState([]);
  const [active, setActive] = useState(null);

  const load = () => api.get("/contact").then(({ data }) => setMessages(data));
  useEffect(() => { load(); }, []);

  const open = async (m) => {
    setActive(m);
    if (!m.read) {
      try {
        await api.post(`/contact/${m.id}/read`);
        load();
      } catch (err) {
        console.error("Failed to mark letter as read:", err);
      }
    }
  };

  const remove = async (id) => {
    if (!window.confirm("Delete this letter?")) return;
    try {
      await api.delete(`/contact/${id}`);
      toast.success("Deleted");
      setActive(null);
      load();
    } catch { toast.error("Could not delete"); }
  };

  return (
    <AdminLayout title="Letters">
      <Toaster position="top-center" />
      <div className="flex items-baseline justify-between flex-wrap gap-4">
        <p className="text-[#5C6670] font-light">Notes from readers, in the order they arrived.</p>
        <div className="text-right" data-testid="messages-total-count">
          <div className="text-[0.65rem] tracking-[0.28em] uppercase text-[#5C6670]">People who have written in</div>
          <div className="font-serif text-3xl text-[#C5A059]">{messages.length.toLocaleString()}</div>
        </div>
      </div>
      <div className="mt-10 grid grid-cols-1 lg:grid-cols-12 gap-6">
        <div className="lg:col-span-5 bg-white border border-[#E5E5E5]">
          {messages.length === 0 && <div className="p-8 text-sm text-[#5C6670]">No letters yet.</div>}
          {messages.map((m) => (
            <button
              key={m.id}
              onClick={() => open(m)}
              data-testid={`message-${m.id}`}
              className={`w-full text-left px-5 py-4 border-b border-[#E5E5E5] hover:bg-[#FAFAFA] transition-colors ${active?.id === m.id ? "bg-[#FAFAFA]" : ""}`}
            >
              <div className="flex items-center justify-between">
                <div className="font-serif text-lg text-[#1A1F24] truncate">{m.name}</div>
                {!m.read && <span className="w-2 h-2 rounded-full bg-[#C5A059]" />}
              </div>
              <div className="text-xs text-[#5C6670] mt-1 truncate">{m.email}</div>
              <p className="text-sm text-[#5C6670] mt-2 line-clamp-2">{m.message}</p>
              <div className="text-xs tracking-[0.18em] uppercase text-[#5C6670] mt-2">
                {new Date(m.created_at).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" })}
              </div>
            </button>
          ))}
        </div>
        <div className="lg:col-span-7 bg-white border border-[#E5E5E5] p-8 min-h-[300px]" data-testid="message-detail">
          {!active && <p className="text-sm text-[#5C6670]">Select a letter to read.</p>}
          {active && (
            <div>
              <div className="gv-label">From</div>
              <div className="font-serif text-2xl text-[#1A1F24] mt-2">{active.name}</div>
              <div className="text-sm text-[#5C6670] mt-1">
                <a href={`mailto:${active.email}`} className="gv-link">{active.email}</a>
              </div>
              <div className="text-xs text-[#5C6670] mt-3">{new Date(active.created_at).toLocaleString()}</div>
              <div className="mt-8 whitespace-pre-wrap text-[#1A1F24] text-base leading-relaxed border-l-2 border-[#C5A059] pl-6">{active.message}</div>
              <div className="mt-10 flex justify-between">
                <a href={`mailto:${active.email}?subject=Re: your letter`} className="gv-btn-gold" data-testid="message-reply">Reply by email</a>
                <button onClick={() => remove(active.id)} className="text-xs tracking-[0.2em] uppercase text-[#5C6670] hover:text-red-500" data-testid="message-delete">Delete</button>
              </div>
            </div>
          )}
        </div>
      </div>
    </AdminLayout>
  );
}
